import Item from './Item'
import OrderedList from './OrderedList'

OrderedList.Item = Item

export default OrderedList



// WEBPACK FOOTER //
// ./src/components/OrderedList/index.js